import { __rest, __assign, __spreadArray, __read } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { VehicleOutline } from './vehicleOutline/VehicleOutline.js';
import styles from './CarPartSelector.module.scss.js';
import { CarPart } from './carPart/CarPart.js';

var parts = [
    { id: 'front-left-corner', label: 'Front left corner', size: 'default' },
    { id: 'front', label: 'Front', size: 'default' },
    { id: 'front-right-corner', label: 'Front right corner', size: 'default' },
    { id: 'front-left-side', label: 'Front left side', size: 'large' },
    { id: 'hood', label: 'Hood', size: 'large' },
    { id: 'front-right-side', label: 'Front right side', size: 'large' },
    { id: 'left-side', label: 'Left side', size: 'large' },
    { id: 'roof', label: 'Roof', size: 'large' },
    { id: 'right-side', label: 'Right side', size: 'large' },
    { id: 'rear-left-side', label: 'Rear left side', size: 'large' },
    { id: 'trunk', label: 'Trunk', size: 'large' },
    { id: 'rear-right-side', label: 'Rear right side', size: 'large' },
    { id: 'rear-left-corner', label: 'Rear left corner', size: 'default' },
    { id: 'rear', label: 'Rear', size: 'default' },
    { id: 'rear-right-corner', label: 'Rear right corner', size: 'default' },
];
var CarPartSelector = function (_a) {
    var _b = _a.inputProps, value = _b.value, onChange = _b.onChange, className = _a.className, children = _a.children, props = __rest(_a, ["inputProps", "className", "children"]);
    var onToggle = function (id) {
        return value.includes(id) ? onChange(value.filter(function (v) { return v !== id; })) : onChange(__spreadArray(__spreadArray([], __read(value), false), [id], false));
    };
    return (jsxs("fieldset", __assign({}, props, { className: clsx(className, styles.carPartSelector) }, { children: [children, jsxs("div", __assign({ className: styles.wrapper }, { children: [jsx(VehicleOutline, { className: styles.vehicleOutline }), jsx("div", __assign({ className: styles.parts }, { children: parts.map(function (part) { return (jsx(CarPart, __assign({}, part, { isSelected: value.includes(part.id), onToggle: onToggle }), part.id)); }) }))] }))] })));
};

export { CarPartSelector };
